import { render, staticRenderFns } from "./PlantingList.html?vue&type=template&id=c2d8bb06&external"
import script from "./PlantingList.ts?vue&type=script&lang=ts&external"
export * from "./PlantingList.ts?vue&type=script&lang=ts&external"
import style0 from "./PlantingList.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports